import { Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import L from "leaflet";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Marker, Popup } from "react-leaflet";
import { DeviceWithState } from "../Device";
import { coordinateFormatter, getDeviceStatusColor, getDeviceStatusOrder, getLocalDateStringFromUtcDateString } from "../Helper";

export type DeviceMarkerProps = {
    deviceWithState: DeviceWithState;
};

export const DeviceMarker: React.FC<DeviceMarkerProps> = (props: DeviceMarkerProps) => {
    const { t, i18n } = useTranslation();
    const { deviceWithState } = props;

    const color = getDeviceStatusColor(deviceWithState.deviceState.status);

    // Custom pin icon
    const pinIcon = new L.Icon({
        iconUrl: require('../pic/' + color + '_pin.png'),
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
    })

    const zIndexOffset = useMemo(() => getDeviceStatusOrder(deviceWithState.deviceState.status) * -1000, [deviceWithState.deviceState.status]);
    return <Marker
        position={[deviceWithState.deviceState.latitude!, deviceWithState.deviceState.longitude!]}
        icon={pinIcon}
        title={deviceWithState.deviceDescriptor.name}
        zIndexOffset={zIndexOffset}
    >
        <Popup>
            <Grid container style={{ justifyContent: "center", maxWidth: '280px' }}>
                <Grid>
                    <Typography>{deviceWithState.deviceDescriptor.name}</Typography>
                </Grid>
                <Grid>
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell variant="body" style={{ width: '53%' }}>{i18n.t('device.status.title')}</TableCell>
                                <TableCell variant="body">{t('device.status.' + deviceWithState.deviceState.status.toLowerCase())}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="body">{t('device.location.title')}</TableCell>
                                <TableCell variant="body">
                                    {t('device.location.latitude', { latitude: coordinateFormatter(i18n.language).format(deviceWithState.deviceState.latitude!) })}
                                    <br />
                                    {t('device.location.longitude', { longitude: coordinateFormatter(i18n.language).format(deviceWithState.deviceState.longitude!) })}
                                    <br />
                                    <a href={`https://www.google.com/maps/dir/?api=1&destination=${deviceWithState.deviceState.latitude},${deviceWithState.deviceState.longitude}&travelmode=driving`} target="_blank" rel="noopener noreferrer">
                                        {i18n.t('device.googleMaps')}
                                    </a>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="body">{i18n.t('device.battery')}</TableCell>
                                <TableCell variant="body">{deviceWithState.deviceState.battery}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="body">{t('device.temperature')}</TableCell>
                                <TableCell variant="body">{deviceWithState.deviceState.temperature}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="body">{t('device.signal_strength')}</TableCell>
                                <TableCell variant="body">{deviceWithState.deviceState.signalStrength}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="body">{t('device.last_seen')}</TableCell>
                                <TableCell variant="body">{getLocalDateStringFromUtcDateString(deviceWithState.deviceState.lastSeen, i18n.language)}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>
        </Popup>
    </Marker>;
}
